<span mat-dialog-title class="dialog-title" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <h1>Manage Statuses</h1>
  <button mat-icon-button (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
</span>

<div mat-dialog-content class="main-dialog-content">

  <div class="header-controls-container">

    <div class="toggle-wrapper">
      <button class="toggle-item" [class.active]="activeTab === 'statuses'" (click)="activeTab = 'statuses'">
        Statuses on graph
      </button>
      <button class="toggle-item" [class.active]="activeTab === 'query'" (click)="activeTab = 'query'">
        Query Builder
      </button>
      <button class="toggle-item" [class.active]="activeTab === 'list'" (click)="activeTab = 'list'">
        List of Queries
      </button>
      <button class="toggle-item" [class.active]="activeTab === 'ai'" (click)="activeTab = 'ai'">
        AI
      </button>
    </div>

    <div class="header-actions" *ngIf="activeTab === 'query'">

      <button mat-button class="danger-btn" (click)="clearAllRules()">
        Delete
      </button>

      <div class="split-button-wrapper">
        <button mat-flat-button color="primary" class="split-main" (click)="addRule(ruleSet)">
          Create
        </button>
        <button mat-flat-button color="primary" class="split-arrow" [matMenuTriggerFor]="headerCreateMenu">
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
      </div>

      <mat-menu #headerCreateMenu="matMenu">
        <button mat-menu-item (click)="addRule(ruleSet)">
          <mat-icon>add</mat-icon> Create Rule
        </button>
        <button mat-menu-item (click)="addRuleSet(ruleSet)">
          <mat-icon>view_stream</mat-icon> Create Ruleset
        </button>
      </mat-menu>

    </div>
  </div>

  <div *ngIf="activeTab === 'statuses'" class="tab-wrapper">
    <div class="tab-content">
      <app-status-selector #statusSelector [hierarchy]="localHierarchy" [focusOn]="data.focusOn ?? null"
        (hierarchyChange)="onHierarchyChange($event)"></app-status-selector>
    </div>
  </div>

  <div *ngIf="activeTab === 'query'" class="tab-wrapper bg-gray">
    <div class="tab-content query-builder-content" cdkDropListGroup>
      <!-- Root Drop List -->
      <div cdkDropList [cdkDropListData]="ruleSet.rules" (cdkDropListDropped)="drop($event)" class="root-drop-list">

        <div *ngFor="let topLevelItem of ruleSet.rules; let i = index" cdkDrag class="root-item-wrapper">
          <div *cdkDragPlaceholder class="custom-placeholder card-placeholder"></div>

          <ng-container
            *ngTemplateOutlet="rulesetTemplate; context: {$implicit: topLevelItem, isRoot: true, index: i, parent: ruleSet, last: i === ruleSet.rules.length - 1}"></ng-container>
        </div>

      </div>
    </div>
  </div>
  <ng-container *ngIf="activeTab === 'list'">
    <div class="tab-content list-of-queries-content bg-gray">

      <div class="query-list-header">
        <div class="col-spacer-left"></div>
        <div class="col-name-header">Query Name</div>
        <div class="col-stat-header">Shared with</div>
        <div class="col-stat-header-small center-text">Groups</div>
        <div class="col-stat-header-small center-text">Rulesets</div>
        <div class="col-stat-header-small center-text">Rules</div>
        <div class="col-actions-right"></div>
      </div>

      <div cdkDropList (cdkDropListDropped)="dropQueryListItem($event)" class="query-list">
        <div class="query-list-item" *ngFor="let query of savedQueries" cdkDrag [cdkDragData]="query">

          <div class="item-left-controls">
            <mat-icon class="drag-handle-icon" cdkDragHandle>drag_indicator</mat-icon>
            <button mat-icon-button color="primary" (click)="loadQuery(query)" matTooltip="Edit in Query Builder">
              <mat-icon>arrow_forward</mat-icon>
            </button>
            <mat-slide-toggle [(ngModel)]="query.isActive" color="primary"></mat-slide-toggle>
          </div>

          <div class="col-name use-ellipsis" [title]="query.name">
            <span class="query-name-text">{{ query.name }}</span>
          </div>

          <div class="col-stat text-blue">{{ query.sharedWithCount }} members</div>
          <div class="col-stat-small center-text text-blue">{{ query.groupCount }}</div>
          <div class="col-stat-small center-text text-blue">{{ query.rulesetCount }}</div>
          <div class="col-stat-small center-text text-blue">{{ query.ruleCount }}</div>

          <div class="col-actions-right">

            <button mat-icon-button class="action-icon-btn" (click)="cloneQuery(query)" matTooltip="Clone Query">
              <mat-icon>content_copy</mat-icon>
            </button>

            <button mat-icon-button class="action-icon-btn" matTooltip="Share Query" (click)="openShareView(query)">
              <mat-icon>share</mat-icon>
            </button>

            <button mat-icon-button class="action-icon-btn delete-icon-btn" (click)="deleteQuery(query)"
              matTooltip="Delete Query">
              <mat-icon>delete_outline</mat-icon>
            </button>

          </div>

          <div *cdkDragPreview class="query-list-item drag-preview">
            <span class="query-name-text">{{ query.name }}</span>
          </div>

        </div>
      </div>
    </div>
  </ng-container>


  <!-- AI TAB -->
  <ng-container *ngIf="activeTab === 'ai'">
    <div class="tab-content ai-view-content">
      <div class="ai-center-container">
        <h3 class="ai-prompt-text">Ask me anything about your data.</h3>
        <div class="ai-input-wrapper">
          <input type="text" placeholder="Ask Something..." [(ngModel)]="aiInput" (keyup.enter)="submitAiQuery()"
            class="ai-input">
          <button mat-icon-button class="ai-send-btn" (click)="submitAiQuery()" [disabled]="!aiInput.trim()">
            <mat-icon>send</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- SHARE QUERY TAB -->
  <ng-container *ngIf="activeTab === 'share'">
    <div class="tab-content share-view-content">

      <!-- Header -->
      <div class="share-header">
        <button mat-icon-button (click)="goBackToQueryList()" class="back-btn">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h2 class="share-title">Share "{{ selectedQuery?.name }}"</h2>
      </div>

      <!-- Controls -->
      <div class="share-controls">
        <div class="search-wrapper">
          <input type="text" placeholder="Search by Name..." [(ngModel)]="searchQuery" class="share-search-input">
          <mat-icon class="search-icon">search</mat-icon>
        </div>
        <div class="selection-actions">
          <button mat-button class="deselect-btn" (click)="deselectAllUsers()">Deselect All</button>
          <button mat-button class="select-btn" (click)="selectAllUsers()">Select All</button>
        </div>
      </div>

      <!-- User List Grid -->
      <div class="user-grid">
        <div class="user-item" *ngFor="let user of filteredUsers" (click)="toggleUser(user)">
          <mat-checkbox [checked]="user.selected" (change)="toggleUser(user)" (click)="$event.stopPropagation()"
            color="primary"></mat-checkbox>
          <span class="user-name">{{ user.name }}</span>
        </div>
      </div>

    </div>
  </ng-container>
</div>

<div class="bottom-buttons">
  <div class="footer-left">
    <button mat-button class ="danger-btn" (click)="onCancelClick()" *ngIf="activeTab !== 'share'">Clear All</button>

    <!-- Share View Footer Left -->
    <span *ngIf="activeTab === 'share'" class="share-count-text">
      Already shared with <span class="text-blue">{{ selectedUserCount }} members</span>
    </span>
    <div>
        <button *ngIf="activeTab === 'query'" mat-button class="danger-btn" (click)="onQueryResetClick()">
          Reset
        </button>
    </div>
  </div>


  <div class="footer-right">

    <ng-container *ngIf="activeTab === 'statuses'">
      <div style="position: relative; display: inline-block;">
        <span *ngIf="showAppliedMessage" class="applied-feedback-popup">
          <mat-icon>check_circle</mat-icon> Statues Applied
        </span>
        <button mat-flat-button color="primary" class="blue-theme" (click)="onManageStatusApplyClick()">Apply</button>
      </div>
    </ng-container>

    <ng-container *ngIf="activeTab === 'query'">
      <button mat-stroked-button color="primary" class="blue-outline-theme"
        (click)="saveQueryAndSwitchTab()">
        Save a Query
      </button>
      <div class="split-button-wrapper">
        <button mat-flat-button color="primary" class="split-main" (click)="onQueryApplyClick(false)">Apply</button>
        <button mat-flat-button color="primary" class="split-arrow" [matMenuTriggerFor]="listApplyMenu">
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
      </div>
      <mat-menu #listApplyMenu="matMenu">
        <button mat-menu-item (click)="onQueryApplyClick(false)">Apply Selection to Page</button>
        <button mat-menu-item (click)="onQueryApplyClick(true)">Apply Selection to DB</button>
      </mat-menu>

      <mat-menu #headerCreateMenu="matMenu">
        <button mat-menu-item (click)="addRule(ruleSet)">
          <mat-icon>add</mat-icon> Create Rule
        </button>
        <button mat-menu-item (click)="addRuleSet(ruleSet)">
          <mat-icon>view_stream</mat-icon> Create Ruleset
        </button>
      </mat-menu>
    </ng-container>

    <!-- Share View Footer Right -->
    <ng-container *ngIf="activeTab === 'share'">
      <button mat-flat-button color="primary" (click)="shareQuery()">Share Query</button>
    </ng-container>


    <ng-container *ngIf="activeTab === 'list'">
      <div class="split-button-wrapper">
        <button mat-flat-button color="primary" class="split-main">Apply</button>
        <button mat-flat-button color="primary" class="split-arrow" [matMenuTriggerFor]="listApplyMenu">
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
      </div>
      <mat-menu #listApplyMenu="matMenu">
        <button mat-menu-item>Apply Selection to Page</button>
        <button mat-menu-item>Apply Selection to DB</button>
      </mat-menu>
    </ng-container>

  </div>
</div>

<ng-template #rulesetTemplate let-ruleset let-isRoot="isRoot" let-index="index" let-parent="parent" let-last="last">

  <div class="tree-node" [class.is-root]="isRoot">

    <!-- Ruleset Header Card -->
    <div class="ruleset-header-card">
      <div class="header-left">
        <mat-icon cdkDragHandle class="card-drag-handle">drag_indicator</mat-icon>

        <!-- Collapse Toggle -->
        <button mat-icon-button (click)="toggleCollapse(ruleset)" class="collapse-btn">
          <mat-icon class="rotate-icon" [class.collapsed]="ruleset.isCollapsed">keyboard_arrow_down</mat-icon>
        </button>

        <!-- Checkbox (Bound to enabled property) -->
        <mat-checkbox [(ngModel)]="ruleset.enabled" color="primary" class="ruleset-checkbox" *ngIf="!isRoot"></mat-checkbox>

        <!-- EDITABLE NAME -->
        <div class="editable-title-wrapper">
          <input [(ngModel)]="ruleset.name" class="ruleset-name-input" [class.root-input]="isRoot"
            placeholder="Group Name">
        </div>

        <span class="ruleset-subtitle" *ngIf="ruleset.rules.length > 0"> - {{ ruleset.rules.length }} {{
          ruleset.rules.length === 1 ? 'item' : 'items' }}</span>
      </div>

      <div class="header-right">
        <div class="logic-toggle-group">
          <button class="logic-btn" [class.active]="ruleset.condition === 'and'"
            (click)="ruleset.condition = 'and'">AND</button>
          <button class="logic-btn" [class.active]="ruleset.condition === 'or'"
            (click)="ruleset.condition = 'or'">OR</button>
        </div>

        <button mat-icon-button [matMenuTriggerFor]="createMenu" class="more-btn">
          <mat-icon>more_horiz</mat-icon>
        </button>

        <mat-menu #createMenu="matMenu">
          <button mat-menu-item (click)="addRule(ruleset)">
            <mat-icon>add</mat-icon> Add Rule
          </button>
          <button mat-menu-item (click)="addRuleSet(ruleset)">
            <mat-icon>view_stream</mat-icon> Add Nested Ruleset
          </button>
          <button mat-menu-item (click)="removeItem(parent, index)">
            <mat-icon color="warn">delete</mat-icon> Delete Group
          </button>
        </mat-menu>
      </div>
    </div>

    <!-- Children Container (Indented) -->
    <div class="ruleset-body" *ngIf="!ruleset.isCollapsed">

      <!-- Column Headers (Only if there are rules) -->
      <div class="rules-table-header" *ngIf="hasRules(ruleset)">
        <div class="col-drag"></div>
        <div class="col-toggle"></div>
        <div class="col-num">Rule #</div>
        <div class="col-field">Field</div>
        <div class="col-op">Operator</div>
        <div class="col-val">Statuses / Value</div>
        <div class="col-actions"></div>
      </div>

      <div cdkDropList [cdkDropListData]="ruleset.rules" (cdkDropListDropped)="drop($event)"
        class="rule-list-container">

        <div *ngFor="let item of ruleset.rules; let i = index; let isLastChild = last" cdkDrag
          class="drag-item-wrapper">

          <!-- TREE CONNECTOR LINES -->
          <div class="tree-connector">
            <div class="connector-curve" [class.is-last]="isLastChild"></div>
            <div class="connector-extension" *ngIf="!isLastChild"></div>
            <div class="operator-badge" *ngIf="i > 0" [class.is-or]="ruleset.condition === 'or'">
              {{ ruleset.condition | uppercase }}
            </div>
          </div>

          <div *cdkDragPlaceholder class="custom-placeholder"></div>

          <ng-container [ngSwitch]="item.type">

            <!-- RULE ROW (Card Style) -->
            <div *ngSwitchCase="'rule'" class="rule-row-card">
              <div class="col-drag" cdkDragHandle>
                <mat-icon class="drag-handle-icon">drag_indicator</mat-icon>
              </div>

              <div class="col-toggle">
                <mat-checkbox [(ngModel)]="item.enabled" color="primary"></mat-checkbox>
              </div>

              <div class="col-num">
                <span class="rule-index-text">{{ i + 1 | number:'3.0' }}</span>
              </div>

              <div class="col-field">
                <div class="custom-select-wrapper">
                  <select [(ngModel)]="item.field" (change)="onFieldChange(item)" class="native-select">
                    <option *ngFor="let f of fieldDefinitions" [value]="f.value">{{ f.name }}</option>
                  </select>
                </div>
              </div>

              <div class="col-op">
                <div class="custom-select-wrapper">
                  <select [(ngModel)]="item.operator" (change)="onOperatorChange(item)" class="native-select">
                    <option *ngFor="let op of getFieldDefinition(item.field)?.operators" [value]="op">{{ op | titlecase
                      }}</option>
                  </select>
                </div>
              </div>

              <div class="col-val">
                <!-- SEQUENTIAL UI -->
                <ng-container *ngIf="item.field === 'STATUS_REASON_CODE' && (item.operator === 'followed by' || item.operator === 'followed by directly')">
                    <div class="sequence-builder">
                      <div class="sequence-steps-container">
                        <ng-container *ngFor="let step of item.value; let i = index; trackBy: trackByIndex">
                          
                          <!-- Step -->
                          <div class="sequence-step">
                            <div class="step-badge">{{i + 1}}</div>
                            
                            <!-- Status Selector Trigger -->
                            <div class="step-card" [matMenuTriggerFor]="stepMenu" #menuTrigger="matMenuTrigger">
                              <span class="step-text" [class.placeholder]="!step || step.length === 0">
                                {{ getStatusDisplay(step, 'Select Status') }}
                              </span>
                              <mat-icon class="step-icon">arrow_drop_down</mat-icon>
                            </div>

                            <!-- Status Menu -->
                            <mat-menu #stepMenu="matMenu" class="status-selector-menu" [overlapTrigger]="false">
                              <div class="menu-wrapper" (click)="$event.stopPropagation()">
                                <app-status-selector style="min-width: 500px; height: 400px; display: block" #stepSelector [hierarchy]="activeTab === 'query' ? localHierarchy : baseHierarchy"
                                  [showCheckboxes]="true"
                                  [initialSelection]="step"
                                  [startClean]="true"
                                  [allowColorChange]="false"
                                  (hierarchyChange)="updateStatusRuleValue(item, stepSelector, 'value', i)">
                                </app-status-selector>
                                <div class="validation-warning" *ngIf="step && step.length > 1" style="color: #f44336; padding: 0 16px 8px 16px; font-size: 12px;">
                                  <mat-icon style="font-size: 14px; height: 14px; width: 14px; vertical-align: middle; margin-right: 4px;">warning</mat-icon>
                                  Only 1 status should be selected
                                </div>
                                <div class="inline-selector-actions">
                                  <button mat-button class="btn-sm" (click)="menuTrigger.closeMenu()">Done</button>
                                </div>
                              </div>
                            </mat-menu>

                            <!-- Remove Step -->
                            <button *ngIf="item.value.length > 2" mat-icon-button class="remove-step-btn" (click)="removeSequenceStep(item, i)">
                              <mat-icon>close</mat-icon>
                            </button>
                          </div>

                          <!-- Connector Arrow (if not last) -->
                          <div *ngIf="i < item.value.length - 1" class="step-connector">
                            <span class="arrow-text">{{ item.operator === 'followed by directly' ? 'Direct' : 'Gap' }}</span>
                            <mat-icon>arrow_forward</mat-icon>
                          </div>

                        </ng-container>

                        <!-- Add Step Button -->
                        <button mat-stroked-button class="add-step-btn" (click)="addSequenceStep(item)">
                          <mat-icon>add</mat-icon> Add Step
                        </button>
                      </div>
                    </div>
                </ng-container>

                <!-- DURATION BETWEEN UI -->
                <ng-container *ngIf="item.field === 'STATUS_REASON_CODE' && item.operator === 'duration between'">
                  <div class="duration-builder" style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                    
                    <!-- From Status -->
                    <div [matMenuTriggerFor]="startMenu" #startMenuTrigger="matMenuTrigger" class="native-input fake-select" style="min-width: 120px;">
                      <span [class.placeholder-text]="!item.startStatus?.length">{{ getStatusDisplay(item.startStatus, 'From Status') }}</span>
                    </div>
                    <mat-menu #startMenu="matMenu" class="status-selector-menu">
                      <div class="menu-wrapper" (click)="$event.stopPropagation()">
                        <app-status-selector style="min-width: 500px; height: 400px; display: block" #startSelector 
                          [hierarchy]="activeTab === 'query' ? localHierarchy : baseHierarchy"
                          [showCheckboxes]="true"
                          [initialSelection]="item.startStatus"
                          [startClean]="true"
                          [allowColorChange]="false"
                          (hierarchyChange)="updateStatusRuleValue(item, startSelector, 'start')">
                        </app-status-selector>
                        <div class="inline-selector-actions">
                          <button mat-button (click)="startMenuTrigger.closeMenu()">Done</button>
                        </div>
                      </div>
                    </mat-menu>

                    <span>to</span>

                    <!-- To Status -->
                    <div [matMenuTriggerFor]="endMenu" #endMenuTrigger="matMenuTrigger" class="native-input fake-select" style="min-width: 120px;">
                      <span [class.placeholder-text]="!item.endStatus?.length">{{ getStatusDisplay(item.endStatus, 'To Status') }}</span>
                    </div>
                    <mat-menu #endMenu="matMenu" class="status-selector-menu">
                      <div class="menu-wrapper" (click)="$event.stopPropagation()">
                        <app-status-selector style="min-width: 500px; height: 400px; display: block" #endSelector 
                          [hierarchy]="activeTab === 'query' ? localHierarchy : baseHierarchy"
                          [showCheckboxes]="true"
                          [initialSelection]="item.endStatus"
                          [startClean]="true"
                          [allowColorChange]="false"
                          (hierarchyChange)="updateStatusRuleValue(item, endSelector, 'end')">
                        </app-status-selector>
                        <div class="inline-selector-actions">
                          <button mat-button (click)="endMenuTrigger.closeMenu()">Done</button>
                        </div>
                      </div>
                    </mat-menu>

                    <!-- Operator Type -->
                    <div class="custom-select-wrapper" style="width: 80px;">
                      <select [(ngModel)]="item.operatorType" class="native-select">
                        <option value="BETWEEN">Between</option>
                        <option value="=">=</option>
                        <option value="<=">&lt;=</option>
                        <option value=">=">&gt;=</option>
                      </select>
                    </div>

                    <!-- Values -->
                    <ng-container *ngIf="item.operatorType === 'BETWEEN'; else singleValueBlock">
                      <input type="number" [(ngModel)]="item.min_days" class="native-input" style="width: 60px;" placeholder="Min">
                      <span>and</span>
                      <input type="number" [(ngModel)]="item.max_days" class="native-input" style="width: 60px;" placeholder="Max">
                      <span>days</span>
                    </ng-container>
                    <ng-template #singleValueBlock>
                      <input type="number" [(ngModel)]="item.value" class="native-input" style="width: 60px;" placeholder="Days">
                      <span>days</span>
                    </ng-template>

                  </div>
                </ng-container>

                <!-- STANDARD STATUS UI -->
                <ng-container *ngIf="item.field === 'STATUS_REASON_CODE' && item.operator !== 'duration between' && item.operator !== 'followed by' && item.operator !== 'followed by directly'">
                  <div [matMenuTriggerFor]="editMenu" #menuTrigger="matMenuTrigger" class="native-input fake-select">
                    <span [class.placeholder-text]="!item.value?.length">{{ getStatusDisplay(item.value) }}</span>
                  </div>
                  <mat-menu #editMenu="matMenu" class="status-selector-menu">
                    <ng-template matMenuContent>
                      <div class="status-selector-menu-content" (click)="$event.stopPropagation()">
                        <app-status-selector style="min-width: 500px; height: 400px; display: block" #selector
                          [hierarchy]="baseHierarchy" [showCheckboxes]="true" [initialSelection]="item.value" [startClean]="true" [allowColorChange]="false"></app-status-selector>
                        <div class="inline-selector-actions">
                          <button mat-button
                            (click)="updateStatusRuleValue(item, selector, 'value'); menuTrigger.closeMenu()">Done</button>
                        </div>
                      </div>
                    </ng-template>
                  </mat-menu>
                </ng-container>

                <ng-container *ngIf="getFieldDefinition(item.field)?.type === 'category'">
                  <div class="custom-select-wrapper">
                    <select [(ngModel)]="item.value" class="native-select">
                      <option *ngFor="let opt of getFieldDefinition(item.field)?.options" [value]="opt.value">{{
                        opt.name }}</option>
                    </select>
                  </div>
                </ng-container>

                <ng-container
                  *ngIf="getFieldDefinition(item.field)?.type !== 'status' && getFieldDefinition(item.field)?.type !== 'category' && item.operator !== 'first' && item.operator !== 'latest'">

                  <!-- DATE PICKER LOGIC -->
                  <div [ngSwitch]="item.operator" class="date-picker-wrapper">

                    <!-- RANGE PICKER -->
                    <mat-form-field *ngSwitchCase="'is between'" appearance="outline" class="compact-date-range">
                      <mat-date-range-input [rangePicker]="rangePicker">
                        <input matStartDate placeholder="Start" [(ngModel)]="item.value.start">
                        <input matEndDate placeholder="End" [(ngModel)]="item.value.end">
                      </mat-date-range-input>
                      <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
                      <mat-date-range-picker #rangePicker></mat-date-range-picker>
                    </mat-form-field>

                    <!-- SINGLE DATE PICKER -->
                    <mat-form-field *ngSwitchDefault appearance="outline" class="compact-date">
                      <input matInput [matDatepicker]="picker" [(ngModel)]="item.value">
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>

                  </div>

                </ng-container>
              </div>

              <div class="col-actions">
                <button mat-icon-button [matMenuTriggerFor]="ruleMenu">
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #ruleMenu="matMenu">
                  <button mat-menu-item (click)="removeItem(ruleset, i)">Delete</button>
                </mat-menu>
              </div>
            </div>

            <!-- NESTED RULESET -->
            <div *ngSwitchCase="'ruleset'" class="nested-ruleset-wrapper">
              <ng-container
                *ngTemplateOutlet="rulesetTemplate; context: {$implicit: item, isRoot: false, index: i, parent: ruleset, last: i === ruleset.rules.length - 1}"></ng-container>
            </div>

          </ng-container>
        </div>
      </div>

      <div class="empty-state" *ngIf="ruleset.rules.length === 0">
        No rules defined.
      </div>

    </div>
  </div>
</ng-template>